import { useIntl} from "react-intl";
import PropTypes from "prop-types";
import React from "react";
import {Redirect, Switch} from "react-router-dom";
import {LANGUAGE} from "../../../common/i18n/locales/localeConstant";
import {useI18N} from "../../../common/common";

const LocalizedSwitch = ({
    children
}) => {
    const { locale } = useIntl();
    const {i18n} = useI18N();

    let foundKeysFromLocale = [];
    let foundMatchingElementsAccordingToPath = [];
    let fromRedirectFoundKeys = [];
    let indexToMatchingElementsArray = 0;


    /**
     * Return matching elements from foundKeysFromLocale array and specified path
     */
    const findValueInArray = (searchValue) => {
        foundKeysFromLocale.forEach( (element) => {
            searchValue === element ? foundMatchingElementsAccordingToPath[indexToMatchingElementsArray++] = element : null;
        });
        return foundMatchingElementsAccordingToPath;
    };

    /**
     * Return localized path dynamically for children of LocalizedSwitch and the redirect which we want to for the translated url
     * Compute the translation of each part of the path which is splitted then computed and then joined again
     * If locale is "en-gb" and there is no locale at the url return just the path
     */
    const localizeRoutePath = (path, fromRedirect) => {
        if(!path) {
            return `/${locale}` + "/";
        }

        if (locale === LANGUAGE.EN && window.location.pathname.split("/")[1] !== LANGUAGE.EN) {
            return path;
        }
        let split = path.split("/");
        let computedRoute;

        fromRedirectFoundKeys = [];


        fromRedirect && fromRedirectFoundKeys.length > 0 ? split = fromRedirectFoundKeys : null;
        foundKeysFromLocale = [];
        foundMatchingElementsAccordingToPath = [];


        indexToMatchingElementsArray = 0;
        split.forEach( el => {
            findValueInArray(el);
        });

        split.includes("") ? split.shift() : null;

        switch (typeof path) {
            case "undefined":
                return undefined;
            case "object":
                return path.map(key => `/${locale}` + i18n(key) );
            default :
                computedRoute = foundMatchingElementsAccordingToPath.length > 0 ? foundMatchingElementsAccordingToPath.join("/") : split.length > 1 ? split.join("/") : split[0];
                return `/${locale}` + "/" + computedRoute + "/";
        }
    };
    return (
        <Switch>
            {React.Children.map(children, child =>
                React.isValidElement(child)
                    ? React.cloneElement(child, {
                        ...child.props,
                        path: localizeRoutePath(child.props.path, false).toString()
                            .toLowerCase()
                    })
                    : child

            )}
            {(/**
                 * Redirect to path which computes the localizeRoutePath function with the chosen locale from url
                 */
                <Redirect
                    to={localizeRoutePath(window.location.pathname.split("/")[1].match(/[a-z]{2}-[a-z]{2}/) ?
                        "/" + window.location.pathname.replace(/\/[a-z]{2}-[a-z]{2}\//, "") : "/" + window.location.pathname, true).toString()
                        .toLowerCase()}
                />
            )
            }
        </Switch>
    );
};

LocalizedSwitch.propTypes = {
    children: PropTypes.any
};

export default LocalizedSwitch;
